// Pure helpers for showing consent-link progress on roster rows.
//
// Module format: CommonJS (module.exports), matching workflow.js — Jest reads
// this file directly and esbuild interops the require from ESM pages.

// listConsentLinks() returns rows newest-first, but don't rely on ordering —
// pick each patient's most recent link by createdAt.
function latestConsentLinkByPatient(links) {
  const map = {};
  for (const l of links || []) {
    if (!l || !l.patientId) continue;
    const prev = map[l.patientId];
    if (!prev || new Date(l.createdAt) > new Date(prev.createdAt)) map[l.patientId] = l;
  }
  return map;
}

// → { label, tone: 'info'|'ok'|'warn' } | null (null = show nothing).
// 'approved' normally vanishes on the next roster reload (consent flips to
// signed, the row leaves the pending pool) — except the declined_on_file
// case, where the patient tapped agree but a documented decline blocked the
// write; that needs a staff phone call, so it renders as a warning.
function consentLinkBadge(link) {
  if (!link) return null;
  if (link.status === 'sent') return { label: 'Link sent', tone: 'info' };
  if (link.status === 'opened') return { label: 'Link opened', tone: 'info' };
  if (link.status === 'approved') {
    return (link.flags || []).includes('declined_on_file')
      ? { label: 'Link approved — decline on file, call to reconcile', tone: 'warn' }
      : { label: 'Approved via link ✓', tone: 'ok' };
  }
  if (link.status === 'expired') return { label: 'Link expired', tone: 'warn' };
  return null; // voided (or unknown) — staff cancelled it; nothing to surface
}

module.exports = { latestConsentLinkByPatient, consentLinkBadge };
